import React from "react";
import { connect } from "react-redux";
import {
    Input,
    Row,
    Col,
    Label,
    FormGroup,
} from "reactstrap";
import SystemLabel from "../../../../system/SystemLabel/SystemLabel";
import InheritageButtonGroup from "../../../components/editor/tools/Inheritage/InheritageButtonGroup";
import JirangoSwitch from "../../../../components/UI/Switch/JirangoSwitch";
import ListExpansion from "../../../../components/UI/ListExpansion/ListExpansion";
import { cmsActions } from "../../../../store/actions/cms/cms.action";
import { deepClone } from "../../../../helpers/objectHelper";
import { templateActions } from "../../../../store/actions/cms/template/template.action";

class TemplateInternalSettings extends React.Component {
    state = {

        confirmationAreaIsExpanded: false,
        navigationAreaIsExpanded: false,
        submitAreaIsExpanded: false,
        templateAreaIsExpanded: false,
    }
    handleChange = (e, val, path) => {
        const { dispatch } = this.props;
        const names = path.split(".");
        const template = deepClone(this.props.template.template);
        let value = val !== null && val !== undefined ? val : e.target.value;

        if (names.length === 1) {
            template[names[0]] = value;
        }
        if (names.length === 2) {
            template[names[0]][names[1]] = value;
        }
        else if (names.length === 3) {
            template[names[0]][names[1]][names[2]] = value;
        }
        else if (names.length === 4) {
            template[names[0]][names[1]][names[2]][names[3]] = value;
        }
        else if (names.length === 5) {
            template[names[0]][names[1]][names[2]][names[3]][names[4]] = value;
        }
        else if (names.length === 6) {
            template[names[0]][names[1]][names[2]][names[3]][names[4]][names[5]] = value;
        }
        template.isChanged = true;

        dispatch(templateActions.softUpdate(template));

    }
    expandArea = area => {
        this.setState({
            [area]: !this.state[area],
        }, () => {
            if (this.state.lastCollapse !== area) {
                if (this.state.lastCollapse !== '') {
                    this.setState({ [this.state.lastCollapse]: false }, () => {
                        this.setState({ lastCollapse: area })
                    })
                }
                else {
                    this.setState({ lastCollapse: area })
                }
            }
        });
    };
    toggleInheritageInfo = (on) => {
        const { dispatch } = this.props;
        dispatch(cmsActions.toggleInheritageInfo(on));
    }
    toggleInheritageStatus = (status) => {
        const { dispatch } = this.props;
        const template = deepClone(this.props.template.template);
        template.inherit = status;
        template.isChanged = true;
        dispatch(templateActions.softUpdate(template));
    }
    render() {
        const { cms } = this.props;
        const {template} = this.props.template
        return (
            <div >
                <ListExpansion
                    footer={false}
                    icon="fa fa-square"
                    defaultExpanded={true}
                    description="GlobalSettings"
                >
                    <Row>
                        <Col className="list-setting-item-title" style={{ flexBasis: 'unset', maxWidth: '100%' }}>
                            <FormGroup style={{ width: '100%' }}>
                                <Label htmlFor="form-name-label"><SystemLabel name={`LocationExpLabel`} /></Label>
                                <Input
                                    id="form-name-label"
                                    autoComplete="jirango-nofill"
                                    value={template.name}
                                    onChange={e => this.handleChange(e, null, `name`)}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                </ListExpansion>
                <br />
                <ListExpansion
                    footer={false}
                    icon="fa fa-square"
                    defaultExpanded={true}
                    description="Inheritage"
                >
                    <Row>
                        <Col
                            className="list-setting-item-title"
                        >
                            <Label>
                                <SystemLabel name="ShowInheritageTooltips" />
                            </Label>
                        </Col>
                        <Col style={{ textAlign: "right", }}>
                            <JirangoSwitch
                                onChange={(e) => this.toggleInheritageInfo(!cms.inheritInfo)}
                                isChecked={
                                    cms.inheritInfo !== true
                                        ? false
                                        : true
                                }
                            />

                        </Col>
                    </Row>
                    <InheritageButtonGroup onClick={this.toggleInheritageStatus} status={template.inherit} />
                </ListExpansion>
              

            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        template: state.template,
        cms: state.cms
    };
}

export default connect(mapStateToProps)(TemplateInternalSettings);
